const process = require('process');
class Utils {

    static get isBankIdJsExecutedInIframe() {
        const isInIframe = window.location !== window.parent.location;
        return isInIframe;
    }

    static get isFirefox() {
        const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        return isFirefox;
    }

    static get isSecureInitFlowActivated() {
        return true;
    }
    
}

export { Utils };